import './DashboardNavbar/DashboardNavbarConfig';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import AtomButton from '../../components/atoms/AtomButton/AtomButton';
import AtomFlex from '../../components/atoms/AtomFlex';
import LightBulbIcon from '../../components/icons/svg/LightBulbIcon';
import { styleConfigs } from '../../components/resources/styleConfigs';
import BoxWrapper from '../../components/wrappers/BoxWrapper';
import { PATH_DASHBOARD_STUDENT } from '../../routes/paths';
import palette from '../../theme/learnerPalette';

const IkigaiButton: React.FC = () => {
  const { t } = useTranslation('DashboardNavbar');
  const navigate = useNavigate();

  return (
    <AtomFlex
      flexDirection="column"
      justifyContent="space-between"
      sx={{ padding: `${styleConfigs.dimensions.width25}px` }}
    >
      <BoxWrapper
        sx={{
          display: 'inline-block',
          borderRadius: `${styleConfigs.borders.radius12}px`,
          padding: `${styleConfigs.marginPadding.custom2}px`,
          background: `linear-gradient(90deg, ${palette.light.background.redViolet} 0%, ${palette.light.background.yaleBlue} 100%)`,
        }}
      >
        <AtomButton
          data-testid="ikigai-button"
          aria-label={t('IKIGAI_BUTTON_LABEL')}
          type="button"
          variant="outlined"
          size="large"
          sx={{
            width: styleConfigs.dimensions.percent100,
            height: `${styleConfigs.dimensions.height56}px`,
            color: palette.light.text.ebonyClay,
            backgroundColor: palette.light.background.white,
            whiteSpace: 'nowrap',
            fontSize: styleConfigs.fonts.sizeText,
            boxShadow: 'none',
            borderColor: 'transparent',
            '&:hover': {
              backgroundColor: palette.light.background.whiteSmoke,
              borderColor: 'transparent',
            },
          }}
          startIcon={
            <LightBulbIcon
              color={palette.light.text.ebonyClay}
              width={styleConfigs.dimensions.width25}
              height={styleConfigs.dimensions.width25}
            />
          }
          onClick={() => navigate(`${PATH_DASHBOARD_STUDENT.admin.occupations}?activeTab=1&showIkigai=1`)}
        >
          {t('IKIGAI_BUTTON_LABEL')}
        </AtomButton>
      </BoxWrapper>
    </AtomFlex>
  );
};

export default IkigaiButton;
